import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {Subject, Subscription} from 'rxjs';
import { Pswd } from 'src/app/model/user';
import { UserProvider } from 'src/app/providers';
import { ToasterService } from 'src/app/services';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  subject: Subject<boolean>;
  changePswdForm: UntypedFormGroup;

  constructor(public bsModalRef: BsModalRef,
    private userProvider: UserProvider,
    private toastr: ToasterService,
    private router: Router,
    private fb: UntypedFormBuilder,) { }

  ngOnInit(): void {
    this.changePswdForm = this.fb.group({
      OLD_PASSWORD: [null, Validators.required],
      NEW_PASSWORD: [null, Validators.compose([Validators.required, Validators.pattern('^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{8,}$')])],
      NEW_CONFIRM_PASSWORD: [null, Validators.compose([Validators.required, this.compareValidator('NEW_PASSWORD')])]
    });
  }

  /**
   * Compare password and confirm password if match
   * @param controlNameToCompare - The control name to compare
  */
   compareValidator(controlNameToCompare: string): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      if (c.value === null || c.value.length === 0) {
        return null;
      }

      const controlToCompare = c.root.get(controlNameToCompare);
      if (controlToCompare) {
        const subscription: Subscription = controlToCompare.valueChanges.subscribe(() => {
          c.updateValueAndValidity();
          subscription.unsubscribe();
        });
      }

      return controlToCompare && controlToCompare.value !== c.value ? { compare: true } : null;
    };
  }

  checkControlValid(controlName: string) {
    const controlDetails = this.changePswdForm.get(controlName);
    if (!controlDetails) {
      return false;
    }
    return (controlDetails.touched || controlDetails.dirty) && controlDetails.invalid;
  }

  /**
   * @description call update password
   */
  update() {
    if (this.changePswdForm.valid) {
      let pswd = new Pswd();
      pswd.OLD_PASSWORD = this.changePswdForm.controls['OLD_PASSWORD'].value;
      pswd.NEW_PASSWORD = this.changePswdForm.controls['NEW_PASSWORD'].value;
      this.userProvider.changePassword(pswd).subscribe(resp => {
        if (resp.success) {
          this.bsModalRef.hide();
          this.toastr.success('Password change successfully!');
        } else {
          this.toastr.error(resp.error.txt);
        }
      }, err => {
        // Error Handling
      })
    } else {
      this.changePswdForm.markAllAsTouched();
    }
  }

  /** Cancel click */
  cancel() {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }
}
